import { IAppState, IRootState } from '@/@types'
import { getEnvVarBoolean, getEnvVarNumber } from '@/helpers/env'

import { GetterTree } from 'vuex'

const getters: GetterTree<IAppState, IRootState> = {
  getSubscriptionsTeamsSelected: state => {
    return state.isSubscriptionsTeamsSelected
  },
  getSubscriptionViewSelected: state => {
    return state.subViewSelected
  },
  getIsBooGoPromoActive: () => {
    return getEnvVarBoolean('VUE_APP_BOOGO_PROMO_ENABLED')
  },
  isBlackFridayActive: () => {
    const timestamp = getEnvVarNumber('VUE_APP_BLACK_FRIDAY_TIMESTAMP')
    if (!timestamp) {
      return false
    }
    const now = new Date().getTime()
    return now > timestamp
  },
  getRunningPreSale: () => {
    return getEnvVarBoolean('VUE_APP_PRE_SALE_ENABLED')
  },
  isLeapYearPromoActive: () => {
    const timestamp = getEnvVarNumber('VUE_APP_RUNNING_PROMOTIONS_TIMESTAMP')
    if (!timestamp) {
      return false
    }
    const now = new Date().getTime()
    return now > timestamp
  },
}

export default getters
